import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl, FormattedMessage, defineMessages} from 'react-intl';
import {Badge, FormControl} from 'react-bootstrap';
import ChannelIcon from '../channel-defs/ChannelIcon.react';
import * as Tool from '../fw/Tool';
import {onInit, initApplicationFilter, clearCache} from './SelectWidget.react';

import './applicationBox.scss';

const allCategories = 'allCategories';

const channelDefTypes = defineMessages({
	"crm": {id: 'webScenarios.channelDefTypes.crm', 'defaultMessage': 'CRM'},
	"invoicing": {id: 'webScenarios.channelDefTypes.invoicing', 'defaultMessage': 'Invoicing'},
	"erp": {id: 'webScenarios.channelDefTypes.erp', 'defaultMessage': 'ERP'},
	"eshop": {id: 'webScenarios.channelDefTypes.eshop', 'defaultMessage': 'e-Shop'},
	"telephony": {id: 'webScenarios.channelDefTypes.telephony', 'defaultMessage': 'Telephony'},
	"mail": {id: 'webScenarios.channelDefTypes.mail', 'defaultMessage': 'Mailing (Mass+Transactional)'},
	"webmail": {id: 'webScenarios.channelDefTypes.webmail', 'defaultMessage': 'WebMail or Mail Client'},
	"projects": {id: 'webScenarios.channelDefTypes.projects', 'defaultMessage': 'Project management'},
	"marketing": {id: 'webScenarios.channelDefTypes.marketing', 'defaultMessage': 'projects'},
	"timetracking": {id: 'webScenarios.channelDefTypes.timetracking', 'defaultMessage': 'Time tracking'},
	"task": {id: 'webScenarios.channelDefTypes.task', 'defaultMessage': 'Task / Issue / Bug'},
	"support": {id: 'webScenarios.channelDefTypes.support', 'defaultMessage': 'Support / Helpdesk'},
	"api": {id: 'webScenarios.channelDefTypes.api', 'defaultMessage': 'API'},
	"email-validation": {id: 'webScenarios.channelDefTypes.email-validation', 'defaultMessage': 'Email validation'},
	"phone-validation": {id: 'webScenarios.channelDefTypes.phone-validation', 'defaultMessage': 'Phone validation'},
	"cnam": {id: 'webScenarios.channelDefTypes.cnam', 'defaultMessage': 'Caller Identification (CNAM)'},
	"vat-validation": {id: 'webScenarios.channelDefTypes.vat-validation', 'defaultMessage': 'VAT number validation'},
	"geolocation": {id: 'webScenarios.channelDefTypes.geolocation', 'defaultMessage': 'Geolocation'},
	"social": {id: 'webScenarios.channelDefTypes.social', 'defaultMessage': 'Social Media'},
	"whois": {id: 'webScenarios.channelDefTypes.whois', 'defaultMessage': 'WHOIS'},
	"maps": {id: 'webScenarios.channelDefTypes.maps', 'defaultMessage': 'Maps'},
	"dativery": {id: 'webScenarios.channelDefTypes.dativery', 'defaultMessage': 'Dativery'},
});

const messages = defineMessages({
	allCategories: {id: 'webScenarios.allCategories', 'defaultMessage': 'All application categories'},
	fulltextPlaceholder: {id: 'webScenarios.fulltextPlaceholder', 'defaultMessage': 'Search for application'},
});

class ApplicationBox extends React.Component {
	static propTypes = {
		applications: PropTypes.array,
		intl: PropTypes.object.isRequired,
	};

	componentDidMount() {
		onInit();
		initApplicationFilter();
	}

	componentWillUnmount() {
		clearCache();
	}

	renderApplicationCategories() {
		if (!this.categories) {
			let categories = {};

			this.props.applications.forEach(({node}) => {
				if (node.tags) {
					node.tags.forEach((tag) => {
						if (tag in channelDefTypes) {
							categories[tag] = true;
						}
					});
				}
			});

			this.categories = Object.keys(categories).map(item => {
				let title = this.props.intl.formatMessage(channelDefTypes[item]);
				return (<option key={item} value={item}>{title}</option>);
			}).sort((itemA, itemB) => {
				return itemA.props.children.toLocaleLowerCase().localeCompare(itemB.props.children.toLocaleLowerCase());
			});
		}

		return this.categories;
	}

	render() {
		let hasApplications = this.props.applications.length !== 0;

		let applications = this.props.applications.sort((itemA, itemB) => {
			return itemA.node.name.toLowerCase().localeCompare(itemB.node.name.toLowerCase());
		});

		return (
			<div className="content-wrapper">
				<div className="layout-row">
					<div className="flex">
						<FormControl className="fulltextSearch" id="fulltextApplicationSearch" placeholder={this.props.intl.formatMessage(messages.fulltextPlaceholder)} type="text" />
					</div>
					<div className="flex-none" style={{width: '8%', minWidth: '20px'}} />
					<div className="flex">
						<FormControl componentClass="select" id="categoryApplicationSearch">
							<option key='-1' value={allCategories}>{this.props.intl.formatMessage(messages.allCategories)}</option>
							{this.renderApplicationCategories()}
						</FormControl>
					</div>
				</div>
				<div className="applicationWidget">

					<div className="applicationBox">
						{
							applications.map(({node}) => {
								return (
									<a className="applicationBoxItem" data-application={JSON.stringify(node)} href="#" id={'app' + node.urlFragment} key={node.realId}>
										<div className="gridList-icon">
											<ChannelIcon channelDef={{icon: node.icon}} size={48}/>
										</div>
										<div className="gridList-title">{Tool.maxTextLength(node.name)}</div>
										<i className="fa fa-check-circle"></i>
									</a>
								);
							})
						}
						<div className={"empty" + (hasApplications ? ' hidden' : '')} key="empty">
							<FormattedMessage defaultMessage="No matching application" id="applicationBox.noMatchingApplications" />
						</div>
					</div>

					<div className="badgeList" id="badgeList">
						<Badge className={"selectedAppBadge clearAll hidden"} id="badgeClearAll" key="clearAll">
							<i className="fa fa-trash-o"></i>
							<FormattedMessage defaultMessage="Clear All" id="scenarioFinder.clearAllBadge" />
						</Badge>
					</div>
				</div>
			</div>
		);
	}
}

export default injectIntl(ApplicationBox);
